<template>
    <div class="page-article">
        <div class="page-article-main">
            <div v-if="articleInfo" class="page-article-content">
                <div class="page-back">
                    <el-button  type="text" @click="backHandle">
                        <i class="el-icon-arrow-left"></i>
                        <span>返回</span>
                    </el-button>
                </div>
                <div class="article-title">{{ articleInfo.articleTitle }}</div>
                <div class="article-author">{{ articleInfo.articleAuthor }}</div>
                <div class="article-content" v-html="articleInfo.articleContent"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "articleDetail",
    props: {
        articleId: {
            type: String,
            default: ""
        },
    },
    watch: {
        articleId() {
            this.getData();
        },
    },
    data() {
        return {
            articleInfo: {}
        }
    },
    methods: {
        getData() {
            this.articleInfo = JSON.parse(localStorage.getItem('articleContent'))
            this.api("viewArticle", { articleId: this.articleInfo.articleId})
        },
        backHandle(){
            this.jump('/pageArticle')
        }
    },
    created() {
        this.getData()
    },
    beforeDestroy() {
        this.articleInfo = {}
    }
}
</script>

<style lang="scss" scoped>
.page-article {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: calc(100% - 1px);
    background: rgb(249, 249, 249);

    .page-article-main {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: calc(100% - 30px);
        overflow: auto;

        .page-article-content {
            position: relative;
            width: 1100px;
            // height: 100%;
            background-color: #fff;
            box-shadow: 0px 4px 10px 0px #EDEDF0;
            margin: 80px auto 30px;
            border-radius: 10px;
            padding: 30px;
            margin-top: 60px;

            .page-back {
                // position: absolute;
                // top: -54px;
                // left: 0;

            }

            .article-title {
                color: rgba(51, 51, 51, 1);
                font-size: 24px;
                font-weight: bold;
                line-height: 40px;
                margin-bottom: 6px;
            }

            .article-author {
                color: rgb(77, 77, 77);
                font-size: 16px;
            }

            .article-content {
                color: rgba(51, 51, 51, 1);
                font-size: 18px;
                font-weight: 400;
                line-height: 25px
            }
        }
    }
    .page-back{
        position: fixed;
        top: 60px;
        background: #fff;
        padding: 0 10px;
        margin-left: -10px;
        border-radius: 0 10px 10px 0;
    }

}
</style>